// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"30627d8b18","253":"5fdc1f4990","619":"95a2aebb06"}[chunkId] + ".js";
};